<template>
  <div class="content">
    <!-- 顶部栏 -->
    <div class="courselist_header">
      <div class="back_to_list">
       视频手工/AI切片列表
      </div>
      <div>
        <a-button
          type="primary"
          style="margin-left: 30px"
          class="ZHIHUISHU_QZMD link_active_btn"
          @click="showModal = !showModal"
        >
          <a-icon type="plus-circle" theme="filled" />
          关联视频
        </a-button>
      </div> 
    </div>
    <!-- 提示栏 -->
    <div class="count_box">
      <div>
        <div>
          切片进度：<span>{{ progress }}</span>
        </div>
      </div>
      <div>未切片状态请及时处理</div>
    </div>
    <!-- 列表 -->
    <div class="classroom-manage">
      <a-table
        :columns="columns"
        :data-source="liveList"
        row-key="id"
        :pagination="false"
        :loading="tabLoading"
        :customRow="customRow"
      >
        <template slot="sliceStatus" slot-scope="text, record">
          <a-tag v-if="record.sliceStatus == '未切片'" color="orange">
            {{ text }}
          </a-tag>
        </template>
        <template slot="liveName" slot-scope="text">
          <span> {{ text }} </span>
        </template>
        <template slot="liveCode" slot-scope="text, record">
          <p>{{ text }}</p>
          <p
            v-if="record.lcLiveId"
          >
            LC:{{ record.lcLiveId }}
          </p>
        </template>
        <template slot="schoolNameAndClassName" slot-scope="text">
          <span>{{
            text
          }}</span>
        </template>
        <template slot="startTime" slot-scope="text">
          <span>{{
            text
          }}</span>
        </template>
        <template slot="endTime" slot-scope="text">
          <span>{{
            text
          }}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="action_box">
            <a-tooltip>
              <template slot="title">回放</template>
              <img
                @click.prevent.stop="backVideoPlay(record)"
                style="
                  width: 20px;
                  height: 20px;
                  cursor: pointer;
                  margin-right: 5px;
                "
                src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/dc10ac55ef3d48ac807d0bc4a266c02c.png"
                alt=""
              />
            </a-tooltip>
            <a-tooltip>
              <template slot="title">分享</template>
              <img
                @click.prevent.stop="getInvitationCode(record)"
                style="
                  width: 20px;
                  height: 20px;
                  cursor: pointer;
                  margin-right: 5px;
                "
                src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/c054994da71046a19233444553407961.png"
                alt=""
              />
            </a-tooltip>
            <a-tooltip>
              <template slot="title">删除</template>
              <img
                @click.prevent.stop="showDeleteConfirm(record)"
                style="
                  width: 20px;
                  height: 20px;
                  cursor: pointer;
                  margin-right: 5px;
                "
                src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/b2b0fcd1a994443dbb8f1a1c05a34b04.png"
                alt=""
              />
            </a-tooltip>
          </div>
        </template>
      </a-table>
      <a-row type="flex" justify="center" style="margin-top: 30px">
        <a-pagination
          v-show="totalCount > 0"
          show-size-changer
          :default-current="1"
          :total="totalCount"
          :defaultPageSize="10"
          @change="handlePageChange"
          @showSizeChange="onShowSizeChange"
          v-model="pageNum"
          :pageSize.sync="pageSize"
        />
      </a-row>
    </div>
    <!-- video: -->
    <drawer-for-vue-core-video-player
      @hideMaskForDrawer="hideMaskForDrawer"
      :drawerFlag="drawerFlag"
      :videoSrc="videoSrc"
      :videoSrcList="videoSrcList"
      @videoSrcChangeByChild="videoSrcChangeByChild"
    />
    <slice-modal
      :showModalProp.sync="showModal"
      @refresh="getActiveDetail"
      title="关联直播"
      @close="showModal = false"
    ></slice-modal>
    <my-dialog
      @hideMask="dialogFlag = false"
      :dialogFlag="dialogFlag"
      width="400px"
      p_lr="0"
    >
      <div class="dialog_inner_container">
        <div class="dialog_inner_container_header">分享直播参加码</div>
        <div class="dialog_inner_container_body">
          <div class="share_list">
            <div class="share_item" v-for="item in shareList" :key="item.title">
              <div class="share_item_top">
                <span class="share_item_top_title">{{ item.title }}：</span>
                <span class="share_item_top_body">{{ item.joinCode }}</span>
              </div>
              <div class="share_item_bottom">
                {{ item.explainText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </my-dialog>
    <my-dialog
      @hideMask="dialogFlagForDelete = false"
      :dialogFlag="dialogFlagForDelete"
      width="330px"
      p_lr="0"
    >
      <div class="dialog_inner_container_for_delete">
        <div class="dialog_inner_container_for_delete_header">提示</div>
        <div class="dialog_inner_container_for_delete_body">
          是否确认解除关联该直播
        </div>
        <div class="dialog_inner_container_for_delete_footer">
          <div
            :class="[
              'dialog_inner_container_for_delete_footer_inner_item',
              index === 1 ? 'm_l15' : '',
              'ZHIHUISHU_QZMD',
            ]"
            v-for="(item, index) in deleteOperationList"
            :key="item.title"
            :style="{
              backgroundColor: item.bgc,
              border: item.border,
              color: item.color,
            }"
            @click="deleteOperationItemClick(item)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="loading_mask" v-if="dialogLoadingForDelete">
          <a-spin />
        </div>
      </div>
    </my-dialog>
    <!-- 融合中 -->
    <a-alert
      v-if="isShowMerge"
      class="merge-box"
      message="视频融合中，请稍等片刻..."
      type="info"
      show-icon
      closable
      @close="onClose"
    />
    <!-- 融合出错 -->
    <div class="error-wrap flex" v-if="isShowError">
      <div class="left-wrap">
        <div class="prompt-wrap">
          <a-icon type="close-circle" style="color: #C5504F;"></a-icon>
          <span>视频融合出错了！</span>
        </div>
        <div class="action" @click="againMerge">重新发起融合</div>
      </div>
      <div class="iconfont icon-closel close-btn" @click="closeError"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import fastLiveStreaming from '../../server/api/fastLiveStreaming'
const columns = [
  {
    title: '状态',
    width: 120,
    dataIndex: 'sliceStatus',
    scopedSlots: { customRender: 'sliceStatus' },
  },
  {
    title: '直播名称',
    dataIndex: 'liveName',
    align: 'center',
    scopedSlots: { customRender: 'liveName' },
  },
  {
    title: 'ID',
    dataIndex: 'liveCode',
    scopedSlots: { customRender: 'liveCode' },
  },
  {
    title: '主讲学校-教室',
    align: 'center',
    dataIndex: 'schoolNameAndClassName',
    scopedSlots: { customRender: 'schoolNameAndClassName' },
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
    scopedSlots: { customRender: 'startTime' },
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    scopedSlots: { customRender: 'endTime' },
  },
  {
    title: '操作',
    width: 115,
    key: 'id',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  components: {
    'class-modal': () => import('../../components/classModal/index'),
    'slice-modal': () => import('../../components/sliceModal/index'),
    'my-dialog': () => import('../../components/my_dialog'),
    'my-drawer': () => import('../../components/my_drawer'),
    'drawer-for-vue-core-video-player': () =>
      import(
        '../../components/componentsForPage/drawer_for_vue_core_video_player'
      ),
  },
  data() {
    return {
      columns,
      isEditCourseName: false,
      activeName: '',
      progress: '',
      liveList: [],
      tabLoading: false,
      customRow: (record, index) => ({
        on: {
          click: () => {
            // 单元行点击事件
            this.operationForGoSupervision(record)
          },
        },
      }),
      dialogFlag: false,
      shareList: [],
      shareList2: [
        {
          title: '老师参加码',
          joinCode: '- -',
          explainText: '老师参加码只能发送给主讲老师，泄漏后可能造成直播异常',
          show: true,
        },
        {
          title: '听课教室参加码',
          joinCode: '- -',
          explainText:
            '听课/互动教室的助教，在“知到-教师版”APP输入该参加码，加入直播课堂',
          show: true,
        },
        {
          title: '观摩旁听参加码',
          joinCode: '- -',
          explainText: '个体学生，在“知到”APP输入该参加码，看直播、回放',
          show: true,
        },
      ],
      activityLiveVoList: [],
      dialogFlagForDelete: false,
      deleteData: {},
      dialogLoadingForDelete: false,
      deleteOperationList: [
        {
          title: '确定解除',
          bgc: '#FFF',
          border: '1px solid #D9D9D9',
          color: '#595959',
          type: 0,
        },
        {
          title: '取消解除',
          bgc: '#5f60d3',
          border: 'none',
          color: '#FFF',
          type: 1,
        },
      ],
      showModal: false,
      schoolCode: '',
      videoSrcList: [],
      videoSrc: '',
      drawerFlag: false,
      totalCount: 0,
      pageNum: 1,
      pageSize: 10,
      isShowMerge: false,
      timer: null,
      isShowError: false,
      errorTimer: null,
      mergeId: 0
    }
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
  },
  mounted() {
    this.getActiveDetail()
  },
  methods: {
    async getActiveDetail() {
      let link = ""
      this.tabLoading = true
      let res = await this.$http.videoSliceList({
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
      this.tabLoading = false
      if (res.code !== 200) {
        return this.$message.error(res.msg || '请求活动详情失败！')
      }
      this.progress = (res.rt.ext?.completeCount || 0) + '/' + (res.rt.ext?.total || 0)
      this.totalCount = res.rt.totalCount
      res.rt.list?.map(item => {
        link = (item.username && item.userId) ? "-" : ""
        item.sliceStatus = item.status == 5 ? "" : "未切片"
        item.liveName = item.videoSource ? "用户上传视频" : item.videoName
        // item.schoolNameAndClassName = item.username + link + item.userId
        // 根据测试所提：主讲学校-教室信息不需要取userid：
        item.schoolNameAndClassName = item.username
        item.liveCode = item.videoSource ? "" : item.liveId
        item.lcLiveId = item.videoSource ? "" : item.lcLiveId
        link = ""
      })
      this.liveList = res.rt.list
    },
    async getInvitationCode(record) {
      let res = await this.$http.getInvitationCode({
        id: record.liveId,
        type: 1,
      })
      if (res.code !== 200) {
        return this.$message.error(res.msg || '获取邀请码失败！')
      }
      if (res.rt[record.liveId]) {
        res.rt[record.liveId].forEach((item, index) => {
          this.shareList2[index].joinCode = item.inviteCode ? item.inviteCode : '- -'
        })
      } else {
        this.shareList2.map(v => {
          v.joinCode = "- -"
        })
      }
      this.shareList = this.shareList2
      this.dialogFlag = true
    },
    showDeleteConfirm(record) {
      this.dialogFlagForDelete = true
      this.deleteData = record
    },
    async getVideoUrl(videoID) {
      // 直接照搬以前的逻辑
      // 老接口：
      // let result = await this.$http.getVideoById({
      //     videoID
      // })
      // 新接口：
      let result = await this.$http.getVideoByIdNew({
        videoID,
      })
      result = result.data
      if (result.errorCode !== 0) return this.$message.error(result.errorMsg)
      let videoObj =
        (result.result.lines || []).find((item) => item.lineUrl) || {}
      if (!videoObj) return this.$message.error('抱歉，暂无视频哦')
      let videoSrc = ''
      videoSrc = videoObj.lineUrl
      return videoSrc
    },
    // 获取视频：
    backVideoPlay({ videoId } = record) {
      if (!videoId)
        return this.$message.error(
          '课程结束1小时后生成回放，请稍后重试！如有问题请联系智慧树运维客服！'
        )
      if (!videoId.length)
        return this.$message.error(
          '课程结束1小时后生成回放，请稍后重试！如有问题请联系智慧树运维客服！'
        )
      this.$nextTick(async () => {
        let videoUrl = []
        if (typeof videoId == 'string') {
          videoUrl = videoId.split(',') || []
        } else {
          videoUrl = videoId
        }
        // this.videoSrc = await this.getVideoUrl(videoUrl)
        // this.drawerFlag = true
        this.videoSrcList = []
        // 首先获取到所有的视频，默认播放第一个：
        for (let i = 0, len = videoUrl.length; i < len; i++) {
          try {
            let videoSrc = await this.getVideoUrl(videoUrl[i])
            this.videoSrcList.push(videoSrc)
          } catch (err) {
            console.log(err, 'err')
          }
        }
        if (this.videoSrcList.length) {
          this.videoSrc = this.videoSrcList[0]
          this.drawerFlag = true
        }
      })
    },
    hideMaskForDrawer() {
      this.drawerFlag = false
    },
    async deleteOperationItemClick({ type }) {
      switch (type) {
        case 0:
          try {
            this.dialogLoadingForDelete = true
            let result = await this.$http.videoSliceDelete({
              id: this.deleteData.id
            })
            this.dialogLoadingForDelete = false
            if (result.code !== 200) return this.$message.error(result.msg)
            let { rt: resultReally } = result
            if (resultReally.resultStatus !== 1)
              return this.$message.error(
                resultReally.resultMessage
                  ? resultReally.resultMessage
                  : '删除失败'
              )
            this.$message.success('删除成功')
            this.dialogFlagForDelete = false
            await this.getActiveDetail()
          } catch (err) {
            console.log(err)
          }
          break
        case 1:
          this.dialogFlagForDelete = false
          break
      }
    },
    videoSrcChangeByChild(videoSrc) {
      this.videoSrc = videoSrc
    },
    async operationForGoSupervision(item) {
      // 1.融合中,2.融合成功,3.融合失败,4.切片中,5.切片成功,6.切片失败
      let { status, videoId, id, videoName } = item;
      if (status == 1) {
        clearTimeout(this.timer)
        clearTimeout(this.errorTimer)
        this.isShowError = false
        this.isShowMerge = true
        this.timer = setTimeout(() => {
          this.isShowMerge = false
        }, 3000)
      } else if (status == 3) {
        clearTimeout(this.timer)
        clearTimeout(this.errorTimer)
        this.isShowMerge = false
        this.isShowError = true
        this.mergeId = id
        this.errorTimer = setTimeout(() => {
          this.isShowError = false
        }, 3000)
      } else {
        let res = await this.$http.checkTranscode({
          id
        })
        if (res.code !== 200) {
          return this.$message.error(res.msg || '转码查询结果错误')
        }
        if (res.rt?.isTranscode) {
          if (videoId) {
            let sign = ''
            videoId.split(',').map(item => {
              sign += item
            })
            const isSample = res.rt.isSample ? 1 : 0
            videoName = encodeURI(encodeURI(videoName))
            window.open(`https://ai-video-h5.zhihuishu.com/videoSection/index.html?source=${sign}&name=${videoName}&special=${isSample}`, '_blank')
          } else {
            this.$message.error('没有播放源')
          }
        } else {
          clearTimeout(this.timer)
          clearTimeout(this.errorTimer)
          this.isShowError = false
          this.isShowMerge = true
          this.timer = setTimeout(() => {
            this.isShowMerge = false
          }, 3000)
        }
      }
    },
    handlePageChange(page, pageSize) {
      this.pageNum = page
      this.pageSize = pageSize
      this.getActiveDetail()
    },
    onShowSizeChange(current, size) {
      this.pageNum = current
      this.pageSize = size
      this.getActiveDetail()
    },
    onClose() {
      clearTimeout(this.timer)
      this.isShowMerge = false
    },
    closeError() {
      clearTimeout(this.errorTimer)
      this.isShowError = false
    },
    async againMerge() {
      let res = await this.$http.videoSliceMerge({
        id: this.mergeId
      })
      if (res.code !== 200) {
        return this.$message.error(res.msg || '发起融合失败')
      }
      this.$message.success(res.msg || '发起融合成功')
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin dialogTitle($color) {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-weight: bold;
  color: $color;
  font-size: 16px;
  border-radius: 10px 10px 0 0;
  padding: 0 30px;
  border-bottom: 1px solid #e7e7e7;
}
@mixin verticalAndCrosswiseCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes scaleCircle {
  from {
    transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(100);
  }
}
::v-deep {
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    border-bottom: 0;
  }
  .ant-table-thead > tr > th {
    background: #f6f6f6;
  }
  .ant-table-tbody {
    tr:nth-child(even) {
      background: #f4f7fa;
    }
    .ant-table-row {
      cursor: pointer;
    }
  }
  .action {
    text-align: center;
    .action-icon {
      cursor: pointer;
    }
  }
  .ant-table-pagination {
    float: none;
    text-align: center;
  }
}
.dialog_inner_container {
  .dialog_inner_container_header {
    @include dialogTitle(#222);
  }
  .dialog_inner_container_body {
    width: 100%;
    height: auto;
    padding: 20px 30px 10px;
    border-radius: 0 0 10px 10px;
    .share_list {
      .share_item {
        width: 100%;
        height: auto;
        padding-bottom: 10px;
        margin-bottom: 20px;
        text-align: left;
        .share_item_top {
          font-weight: bold;
          font-size: 14px;
          position: relative;
          padding-left: 10px;
          .share_item_top_body {
            color: #2090ff;
          }
          &::before {
            content: '';
            width: 3px;
            height: 16px;
            background-color: #5f60d3;
            border-radius: 2px;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .share_item_bottom {
          font-size: 14px;
          color: #858492;
          margin-top: 6px;
        }
        &:nth-of-type(1) {
          .share_item_bottom {
            color: #fe7c14;
          }
        }
      }
    }
  }
}
.courselist_header {
  background-color: #fff;
  box-shadow: 0 0 10px #ddd;
  padding: 25px;
  display: flex;
  justify-content: space-between;
  .back_to_list {
    // cursor: pointer;
    display: flex;
    align-items: center;
  }
  .link_active_btn {
    background: #5f60d3;
    border: none;
  }
}
.end_gray {
  color: #bfbfbf;
}
.count_box {
  height: 60px;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  > div:first-child {
    margin-right: 15px;
    display: flex;
    > div:nth-child(2) {
      margin-left: 50px;
    }
    div {
      > span {
        color: #5f60d3;
        font-weight: bold;
      }
    }
  }
  > div:last-child {
    color: orange;
    padding-right: 30px;
  }
}
.classroom-manage {
  min-height: 996px;
  text-align: left;
  background: #fff;
  box-shadow: 0 0 10px #ddd;
  border-radius: 10px;
}
.dialog_inner_container_for_delete {
  .dialog_inner_container_for_delete_header {
    @include dialogTitle(#222);
  }
  .dialog_inner_container_for_delete_body {
    padding: 15px;
    text-align: center;
  }
  .dialog_inner_container_for_delete_footer {
    width: 100%;
    height: 70px;
    padding-bottom: 23px;
    @include verticalAndCrosswiseCenter();
    .dialog_inner_container_for_delete_footer_inner_item {
      width: 74px;
      height: 32px;
      @include verticalAndCrosswiseCenter();
      font-size: 12px;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
      box-shadow: 0 0 5px #f5f5f5;
      transition: all 0.5s;
      letter-spacing: 1px;
      &:nth-of-type(1) {
        &:hover {
          border: 1px solid #2090ff !important;
          color: #2090ff !important;
        }
      }
      &:nth-of-type(2) {
        &:hover {
          background-color: #48a2fc;
        }
      }
    }
  }
}

// 融合中
::v-deep .merge-box{
  width: 50%;
  height: 55px;
  line-height: 37px;
  text-align: left;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top: 76px;
  .ant-alert-icon{
    font-size: 18px;
    left: 12px;
  }
  .ant-alert-close-icon{
    top: 10px;
    line-height: 36px;
  }
  .anticon{
    line-height: 2;
  }
}

// 融合失败
.error-wrap{
  width: 50%;
  height: 55px;
  font-size: 14px;
  background-color: #FCF1EF;
  border: 1px solid #DAB9B6;
  padding: 0 15px;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top: 76px;
  .left-wrap{
    .prompt-wrap{
      line-height: 1;
      span{
        margin-left: 8px;
      }
    }
    .action{
      margin-top: 8px;
      text-indent: -5px;
      line-height: 1;
      color: #5795E3;
      cursor: pointer;
    }
  }
  .close-btn{
    cursor: pointer;
  }
}
</style>